import React from 'react';
import styles from './SelectMenu.module.css';

const SelectMenu = ({ id, label, options, classes, ...props }) => {
	return (
		<>
			{label && (
				<label htmlFor={id} className='color-header fw-semibold'>
					{label}
				</label>
			)}
			<select
				{...props}
				id={id}
				className={`form-select form-select-lg mb-3 ${styles.select} ${
					classes && classes
				}`}>
				{options.map(({ value, name }) => (
					<option key={value} value={value}>
						{name}
					</option>
				))}
			</select>
		</>
	);
};

export default SelectMenu;
